export default {
  data() {
    return {
      apis: {
        unread:'sh/msg/unread',//未读消息数量接口列表
      },
      userKey: sessionStorage.getItem(this.$global.userKey),
      socket:null,
      msgTotal: 0
    }
  },
  mounted() {
    const me = this;
    if(!me.socket){
      me.initSocket();
    }
    me.loadMsgTotal();
    
  },
  methods: {
    initSocket() {//初始化Socket链接
      const me = this,
        server = (me.$global.baseUrl).replace('http', 'ws'),
        userKey = sessionStorage.getItem(me.$global.userKey);
      if (!userKey) { //如果未获取到用户，则不显示消息
        return;
      }
      me.socket = new WebSocket(server + "sh/ws/" + userKey);
      me.socket.onmessage = me.receiveMsg;
    },
    receiveMsg(msg) {//Websocket接收消息成功
      this.loadMsgTotal();
    },
    loadMsgTotal() {//主动获取未读消息数量
      const me = this;
      me.msgTotal = 0;
      me.$post({
        url : me.apis.unread,
      }).then(rsp=>{
        if(rsp.success){
          me.msgTotal = rsp.retObj;
        }
      })
    }
  },
}



// WEBPACK FOOTER //
// ./src/components/base/view/msg/cmps/icon/src/icon.js